<template>
  <div id="accountSetting">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            帳號設定
          </div>
        </div>
      </div>
      <el-tabs
        id="feeTab"
        v-model="activeName"
        :before-leave="checkTab"
      >
        <el-tab-pane name="changeInfo">
          <span slot="label">基本資料</span>
        </el-tab-pane>
        <el-tab-pane name="changePassword">
          <span slot="label">變更密碼</span>
        </el-tab-pane>
      </el-tabs>
      <router-view ref="view" />
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      activeName: 'changeInfo'
    }
  },
  mounted () {
    this.activeName = this.$route.name
  },
  methods: {
    checkTab (activeName, oldActiveName) {
      if (activeName !== oldActiveName) {
        this.$router.push({ name: activeName })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
#accountSetting
  text-align: center
  padding: 50px 0 10px
  height: 100%
  .main
    // min-width: 1140px
    max-width: 50%
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      margin: 0 0 20px 0
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        margin-bottom: 10px
        text-align: left
#feeTab
  ::v-deep .el-tabs
    +basicTabs
    &__header
      margin: 0 0 0
    &__item
      min-width: 130px
      height: 42px
      span
        width: 100%
        display: inline-block
</style>
